<template>
  <BannerForm />
</template>

<script>
import BannerForm from '@/layouts/components/form/BannerForm.vue'

export default {
  components: { BannerForm },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
